import { CardContent, CircularProgress, Grid } from '@mui/material'
import EDCard from '../../../../../atoms/EDCard/EDCard'

const SchoolLoading = () => {
  return (
    <Grid item xs={12}>
      <EDCard elevation={0}>
        <CardContent>
          <Grid container justifyContent='center'>
            <Grid item>
              <CircularProgress />
            </Grid>
          </Grid>
        </CardContent>
      </EDCard>
    </Grid>
  )
}

export default SchoolLoading
